import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    fontFamily: "'Montserrat', sans-serif",
  },
  palette: {
    primary: {
      main: "#015ff1",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          //fontFamily: "'Montserrat', sans-serif",
          textTransform: "capitalize",
          "&:hover": {
            boxShadow: "#0D3062",
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          //fontFamily: "'Montserrat', sans-serif",
        },
      },
    },
  },
});
